




































import { computed, defineComponent, PropType, ref, toRefs } from '@vue/composition-api';
import { AcoFormData, FullNormalFormData, ImaAppType } from '@tt4b/ttam-enums';
import InstantMessageApp from './index';
import { Validator } from '@tt4b/ttam-hooks';
import { i18n } from '@tt4b/ttam-i18n';

const name = 'ttam-instant-message-app-compose';
export default defineComponent({
  name,
  components: {
    TtamInstantMessageAppList: InstantMessageApp.TtamInstantMessageAppList,
    TtamInstantMessageAppCheck: InstantMessageApp.TtamInstantMessageAppCheck,
    TtamInstantMessageAppMessengerId: InstantMessageApp.TtamInstantMessageAppMessengerId,
    TtamInstantMessageAppWhatsappId: InstantMessageApp.TtamInstantMessageAppWhatsappId,
  },
  props: {
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    imaTypeValidate: {
      type: Array as PropType<Validator>,
      default: () => [],
    },
    imaMessengerIdValidate: {
      type: Array as PropType<Validator>,
      default: () => [],
    },
    imaWhatsappIdValidate: {
      type: Array as PropType<Validator>,
      default: () => [],
    },
    currentLang: {
      type: String,
      require: true,
      default: '',
    },
    currentCreativeUuid: {
      type: String,
      require: true,
      default: '',
    },
    currentAdSource: {
      type: Number,
      require: true,
      default: 0,
    },
    accountCountry: {
      type: String,
      require: true,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { creativeData } = toRefs(props);

    const { ImaAppList } = InstantMessageApp.usePropsImaAppList();

    const messengerIdRef = ref();
    const whatsappIdRef = ref();

    const clearValidate = () => {
      if (creativeData.value.imaType === ImaAppType.MESSENGER) {
        messengerIdRef.value?.imaAccountId?.clearValidate();
      }
      if (creativeData.value.imaType === ImaAppType.WHATSAPP) {
        whatsappIdRef.value?.phoneNumberRef?.clearValidate();
      }
    };

    const _imaType = computed({
      get: () => creativeData.value.imaType,
      set: (val: number) => {
        clearValidate(); // 切换 imaType 的时候清空 imaAccountId 的校验信息
        emit('ima-type-change', val);
      },
    });

    const _imaAccountId = computed({
      get: () => creativeData.value.imaAccountId,
      set: (val: string) => {
        emit('ima-account-id-change', val);
      },
    });

    const _externalUrl = computed(() => creativeData.value.externalUrl);

    const appCheckDesc = computed(() => {
      const scanDesc = i18n.t('creation_check_ima_account_id_scan_desc') as string;
      if (creativeData.value.imaType === ImaAppType.WHATSAPP) {
        const whatsappDesc = i18n.t('creation_check_ima_account_id_desc') as string;
        return `${scanDesc} ${whatsappDesc}`;
      }
      return scanDesc;
    });

    const onPhoneInputValidate = (isValid: boolean) => {
      emit('phone-data-validate', isValid);
    };

    const onPhoneDataChange = phoneData => {
      emit('phone-data-change', phoneData);
    };

    return {
      name,
      ImaAppType,
      _imaType,
      _imaAccountId,
      _externalUrl,
      ImaAppList,
      messengerIdRef,
      whatsappIdRef,
      appCheckDesc,
      onPhoneInputValidate,
      onPhoneDataChange,
    };
  },
});
